export default "__VITE_ASSET__yAvoBHbE__"